import { render, staticRenderFns } from "./DebtorListPrintStatementModal.vue?vue&type=template&id=1526372b&scoped=true"
import script from "./DebtorListPrintStatementModal.vue?vue&type=script&lang=js"
export * from "./DebtorListPrintStatementModal.vue?vue&type=script&lang=js"
import style0 from "./DebtorListPrintStatementModal.vue?vue&type=style&index=0&id=1526372b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1526372b",
  null
  
)

export default component.exports